import { useContext } from "react";
import { AnimatePresence } from "framer-motion"
import { BrowserRouter, Routes, Route,/*, Navigate*/ useNavigate } from "react-router-dom";
import i18n from "i18next"
import detector from "i18next-browser-languagedetector"
import { useTranslation, initReactI18next } from "react-i18next";
import { enus, esmx } from "helpers/languages"
import ThemeMUIProvider from "theme/MainTheme";
import Layout from "./components/Layout";
import Error from "./components/Error/Error";
import Dashboard from "./routes/Dashboard";
import BranchOffice from "./routes/BranchOffice";
import Login from "./routes/Login";
import { AuthContext } from "context/AuthContext";
import User from "routes/User";
import Menu from "routes/Menu";
import MenuDesign from "routes/MenuDesign";
import ProductTag from "routes/ProductTag";
import Promotion from "routes/Promotion";
import Builder from "routes/Builder";
import QrCode from "routes/QrCode";
import Register from "routes/Register";
import Company from "routes/Company";
import Account from "routes/Account";
import PaymentPlan from "routes/PaymentPlan";
import Pricing from "routes/Pricing";

const ProtectRoute = ({ children }) => {
  const navigate = useNavigate()
  const { isAuth } = useContext(AuthContext)
  if (!isAuth) {
    navigate("/login")
  }
  return children
}

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources: {
      es: esmx,
      en: enus
    },
    lng: "es",
    fallbackLng: "es",
    interpolation: { escapeValue: false }
  });

const App = () => {
  const { t } = useTranslation();

  return (
    <ThemeMUIProvider>
      <BrowserRouter>
        <AnimatePresence>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="login" element={<Login />} />
            <Route path="registro" element={<Register />} />
            <Route path="/admin" element={<ProtectRoute> <Layout /> </ProtectRoute>}>
              <Route path="company" element={<Company t={t} />} />
              <Route path="account" element={<Account t={t} />} />
              <Route path="dashboard" element={<Dashboard t={t} />} />
              <Route path="sucursales" element={<BranchOffice />} />
              <Route path="usuarios" element={<ProtectRoute> <User /> </ProtectRoute>} />
              <Route path="menus" element={<ProtectRoute> <Menu /> </ProtectRoute>} />
              <Route path="menu-disenio" element={<ProtectRoute> <MenuDesign /> </ProtectRoute>} />
              <Route path="etiquetas-producto" element={<ProtectRoute> <ProductTag /> </ProtectRoute>} />
              <Route path="promociones" element={<ProtectRoute> <Promotion /> </ProtectRoute>} />
              <Route path="constructor" element={<ProtectRoute> <Builder /> </ProtectRoute>} />
              <Route path="codigos-qr" element={<ProtectRoute> <QrCode /> </ProtectRoute>} />
              <Route path="planes-pago" element={<ProtectRoute> <PaymentPlan /> </ProtectRoute>} />
              <Route path="subscripciones" element={<ProtectRoute> <Pricing /> </ProtectRoute>} />
            </Route>
            <Route path="*" element={<Error />} />
          </Routes>
        </AnimatePresence>
      </BrowserRouter>
    </ThemeMUIProvider>
  );
};

export default App;
